import React, { FC } from 'react';
import { useController } from 'react-hook-form';
import { handleMonthInput, MonthPicker } from '@common/datePicker';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import styles from '../../experience.module.scss';

import DateFormat from '@utils/date/format';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IActivityPeriodProps {
  prefixName: string;
  startDateDefaultValue?: string;
  endDateDefaultValue?: string;
}

const ActivityPeriod: FC<IActivityPeriodProps> = ({ prefixName, startDateDefaultValue, endDateDefaultValue }) => {
  const startDateName = `${prefixName}.startDate`;
  const endDateName = `${prefixName}.endDate`;

  const {
    field: startDateField,
    fieldState: { invalid: startDateInvalid },
  } = useController({
    name: startDateName,
    defaultValue: startDateDefaultValue,
  });
  const selectedStartDate = startDateField.value ? new Date(startDateField.value) : null;
  const handleChangeStartDate = (date: Date | null) => {
    if (!date) return;
    startDateField.onChange(DateFormat.format(date, 'yyyy-MM'));
  };

  const {
    field: endDateField,
    fieldState: { invalid: endDateInvalid },
  } = useController({
    name: endDateName,
    defaultValue: endDateDefaultValue,
  });
  const selectedEndDate = endDateField.value ? new Date(endDateField.value) : null;
  const handleChangeEndDate = (date: Date | null) => {
    if (!date) return;
    endDateField.onChange(DateFormat.format(date, 'yyyy-MM'));
  };

  const startDateInputComplete = !!startDateField.value;
  const endDateInputComplete = !!endDateField.value;

  return (
    <div className={cx('activityWrap')}>
      <div className={cx('activityTitle')}>기간</div>

      <div className={cx('periodArea')}>
        <div className={cx('periodWrap')}>
          <MonthPicker
            selected={selectedStartDate}
            onChange={handleChangeStartDate}
            onChangeRaw={handleMonthInput}
            className={cx('periodInput', { error: startDateInvalid }, { complete: !!startDateField.value })}
            placeholderText="연도. 월"
            maxDate={new Date('9999-12')}
          />
          <ErrorMessage name={startDateName} />
        </div>
        <mark>~</mark>
        <div className={cx('periodWrap')}>
          <MonthPicker
            selected={selectedEndDate}
            onChange={handleChangeEndDate}
            onChangeRaw={handleMonthInput}
            className={cx('periodInput', { error: endDateInvalid }, { complete: !!endDateField.value })}
            placeholderText="연도. 월"
            maxDate={new Date('9999-12')}
          />
          <ErrorMessage name={endDateName} />
        </div>
      </div>
    </div>
  );
};

export default ActivityPeriod;
